
import axios from "axios";

import { IP } from "utils/Host";

// zmiana procesora w grupie z poziomu technologia stage
export function dropStageZmienCzasTrwaniaOprawaGold(targetId,newEndDate,refreshGantAll) {


  console.log("zmiana oprawy")
  
  axios
  .get(IP + "API_0023_gant_procedura_zmien_czas_trwania_oprawa_gold/"+targetId+"/"+newEndDate+"/" + sessionStorage.getItem("token"))
    .then((res) => {
refreshGantAll()

    })
}

//   +"/" + sessionStorage.getItem("token")

